import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";

import useUser from "../../hooks/useUser";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getUserCrewTrainings } from "../../api/training.deprecated";
import useCrew from "../../hooks/useCrew";
import { OkIcon, ExpiredIcon } from "../../components/CourseStatusIcon";

const AssessorTrainings = ({ match, history }) => {
  const { t } = useTranslation();

  const [userCrewTrainings, setUserCrewTrainings] = useState([]);
  const user = useUser();
  const { crew } = useCrew();
  useEffect(() => {
    (async () => {
      const res = await getUserCrewTrainings("assessor", user.id, crew.id);
      setUserCrewTrainings(res);
    })();
  }, []);

  return (
    <>
      <Typography variant="h4">{t("training_pages.assessor_list")}</Typography>
      {userCrewTrainings ? (
        <TableComponent
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("training_pages.training") },
            { title: t("status") },
            { title: t("training_pages.e_learning") },
            { title: t("training_pages.classroom") },
            { title: t("training_pages.practical") },
            { title: t("training_pages.assessor_tasks_done") },
            { title: t("actions") },
          ]}
          renderChildren={(userCrewTraining) => (
            <TableRow key={userCrewTraining.id}>
              <TableCell>{userCrewTraining.training_id}</TableCell>
              <TableCell>{userCrewTraining.displayname}</TableCell>
              <TableCell>{userCrewTraining.status}</TableCell>

              <TableCell>{userCrewTraining.is_e_learning ? t("yes") : t("no")}</TableCell>
              <TableCell>{userCrewTraining.is_classroom ? t("yes") : t("no")}</TableCell>
              <TableCell>{userCrewTraining.is_practical ? t("yes") : t("no")}</TableCell>

              <TableCell>{userCrewTraining.allDone ? <OkIcon /> : <ExpiredIcon />}</TableCell>

              <TableCell>
                <Button
                  icon={<PublishedWithChangesIcon />}
                  onClick={() => history.push(`/training-users/user/${userCrewTraining.training_id}`)}
                  title={t("training_pages.users_checking_progress")}
                />

                <Button
                  icon={<DateRangeIcon />}
                  onClick={() => history.push(`/trainings/schedule/assessor/${userCrewTraining.training_id}`)}
                  title={t("training_pages.schedule_assessment")}
                />

                <Button
                  icon={<AssignmentIcon />}
                  onClick={() => history.push(`/trainings/assessment/${userCrewTraining.training_id}`)}
                  title={t("training_pages.users_assessment")}
                />

                <Button
                  icon={<LibraryAddCheckIcon />}
                  onClick={() =>
                    history.push(
                      `/trainings/checking-progress/assessor/${userCrewTraining.training_id}/${userCrewTraining.instructor_complete}/${userCrewTraining.assessor_passed}/${userCrewTraining.checker_passed}`,
                    )
                  }
                  title={t("training_pages.sign_off_assessor")}
                />
              </TableCell>
            </TableRow>
          )}
          search={["displayname", "fullname", "company_name"]}
          pagination
          items={userCrewTrainings}
        />
      ) : null}
    </>
  );
};

export default AssessorTrainings;
